export default "__VITE_ASSET__ehEcCQq___"